import type { IMediaNode } from '../../collection-subtitles/media-node';
import { vaultGetRequest } from '../helpers';
import { fetchTreeResponseSchema } from './fetch-tree-response';

export async function fetchTreeApi(): Promise<IMediaNode[]> {
  return vaultGetRequest({ path: '/vault/tree', schema: fetchTreeResponseSchema });
}
